import { View, Text } from "@react-pdf/renderer";
import {
  formatHealth,
} from "../../../../../helpers/functions";
import { COLORS, styles } from "../../../../forms/pdf-components/PdfStyles";
import { PdfRow, PdfCol, PdfVerticalDivider } from "../../../../forms/pdf-components/PdfLayout";

/**
 * PdfPatientHeaderRow
 * Compact patient name + health card row used at the top of Pages 2 and 3.
 *
 * Props:
 *   patient — patient object
 */
export const PdfPatientHeaderRow = ({ patient = {} }) => {
  const patientName = [
    patient.firstName,
    patient.middleName,
    patient.lastName,
  ]
    .filter(Boolean)
    .join(" ");

  const healthCard = patient?.provincialInsurance?.cardNumber
    ? `${formatHealth(patient.provincialInsurance.cardNumber)}-${
        patient.provincialInsurance.versionCode || ""
      }`
    : "XXX-XXX-XXX-EF";

  return (
    <View
      style={{
        borderWidth: 1,
        borderColor: COLORS.border,
        backgroundColor: COLORS.bgSection,
        padding: 5,
      }}
    >
      <PdfRow>
        <PdfCol>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.compactLabel}>Patient Name:&nbsp;</Text>
            <Text style={styles.compactValue}>{patientName || "—"}</Text>
          </View>
        </PdfCol>
        <PdfVerticalDivider style={{ marginVertical: 0 }} />
        <PdfCol style={{ paddingLeft: 6 }}>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.compactLabel}>Health Card:&nbsp;</Text>
            <Text style={styles.compactValue}>{healthCard}</Text>
          </View>
        </PdfCol>
      </PdfRow>
    </View>
  );
};
